module.exports = __webpack_public_path__ + "static/Erdbeere-6dc767bd88c76ed00efb687a9866a1da.png";